import React from 'react';
import PropTypes from 'prop-types';
import {Button, ButtonPrimary} from '@homeaway/react-buttons';
import {FormInput} from '@homeaway/react-form-components';
import {SVGIcon} from '@homeaway/react-svg';
import {HEART_SELECTED__16} from '@homeaway/svg-defs/lib/defs/HEART_SELECTED__16';
import {MAX_TRIPBOARD_NAME_LENGTH} from '../../constants';

import './CreateTripBoard.less';

function CreateTripBoard(props) {
    const {
        handleClickCancel,
        handleClickCreate,
        newBoardName,
        onNameChange,
        showCancel,
        translations,
        isMobile,
        createIsDisabled
    } = props;

    const emptyState = translations['tripboards.main.empty.state'];
    const heartMessages = emptyState && emptyState.split('{heart}');

    return (
        <div className="create-trip-board">
            {heartMessages && <div className="create-trip-board__cta">{heartMessages[0]} <SVGIcon inlineFlex markup={HEART_SELECTED__16} className="create-trip-board__cta_heart"/> {heartMessages[1]}</div>}
            <form onSubmit={handleClickCreate}>
            <FormInput
                autoFocus={!isMobile}
                className="create-trip-board__input"
                id="boardInput"
                inputClassName="trip-board-text-input"
                label={translations['tripboards.modal.create.name']}
                maxLength={MAX_TRIPBOARD_NAME_LENGTH}
                value={newBoardName}
                onChange={onNameChange}
            />
            <div className="create-trip-board__buttons">
                {showCancel && (
                    <Button
                        id="cancelButton"
                        className="create-trip-board__buttons_cancel"
                        label={translations['tripboards.cancel']}
                        onClick={handleClickCancel}
                        size="sm"
                    />)
                }
                <ButtonPrimary
                    id="createButton"
                    label={translations['tripboards.modal.create']}
                    disabled={createIsDisabled}
                    onClick={handleClickCreate}
                    size="sm"
                />
            </div>
            </form>
        </div>
    );
}

CreateTripBoard.propTypes = {
    handleClickCancel: PropTypes.func.isRequired,
    handleClickCreate: PropTypes.func.isRequired,
    newBoardName: PropTypes.string.isRequired,
    onNameChange: PropTypes.func.isRequired,
    showCancel: PropTypes.bool.isRequired
};

export default CreateTripBoard;
